import React from 'react';
import styled from 'styled-components';
import { StyledBaseIcon } from './Icons/Base.icon';
import { hexToRgba } from '../services/hex.service';

export interface FloatButtonProps
  extends React.AllHTMLAttributes<HTMLDivElement> {}

export const StyledFloatButton = styled.div<{}>`
  position: fixed;
  right: 20px;
  bottom: 20px;
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.CARD};
  cursor: pointer;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.BLUE.B400};
  box-shadow: 0 0 30px ${({ theme }) => hexToRgba(theme.colors.BLUE.B400, 0.4)};
  transition: all 0.3s;

  ${StyledBaseIcon} {
    transition: all 0.3s;
  }

  :hover {
    box-shadow: 0 0 40px
      ${({ theme }) => hexToRgba(theme.colors.BLUE.B400, 0.6)};

    ${StyledBaseIcon} {
      transform: rotate(180deg);
    }
  }
`;
const FloatButtonComponent = ({ children, onClick }: FloatButtonProps) => {
  return <StyledFloatButton onClick={onClick}>{children}</StyledFloatButton>;
};

export default FloatButtonComponent;
